export default __webpack_public_path__ + "651e3de5263fd96ef76f810f958b21a7.svg";